import React from 'react';
import { CTAButton } from './CTAButton';
const esiIncludes = ['Megapack ESI Secundaria · 25 temas', 'BONUS 1: Banco de Producciones Escritas', 'BONUS 2: Banco de Debates para Secundaria', 'BONUS 3: 50 Actividades de Ciudadanía', 'BONUS 4: Del Aula al Mundo', 'Acceso inmediato y de por vida'];
const packIncludes = ['Megapack ESI Secundaria · 25 temas', '8 Habilidades para Secundaria + los 4 bonus', 'Efemérides Listas Secundaria · todo el año', '3 materiales completos en una sola compra', 'Acceso inmediato y de por vida', 'El mayor ahorro'];
const packMockups = [{
  src: 'https://cdn.magicpatterns.com/uploads/kJGRiJgbNJSpRUTFSsfToC/mockup_8_habilidades.png',
  alt: '8 Habilidades para Secundaria'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/h1ciRHnK421CPcfbBsJCCc/mockup_efemerides.png',
  alt: 'Efemérides Listas Secundaria'
}];
export function PurchaseSection() {
  return <section id="compra" className="py-8 px-4 bg-black text-white text-center" data-id="element-271" data-mp="3ouendrddwnpi">
      <div className="max-w-4xl mx-auto" data-id="element-272" data-mp="y76ixnotadl9">
        <h2 className="text-[20px] font-black mb-6 text-[#9D7FE0]" data-id="element-273" data-mp="y87wbytavc65">
          ACCEDÉ AHORA A MEGAPACK ESI SECUNDARIA
        </h2>

        {/* Opción 1: Megapack ESI Secundaria */}
        <div className="max-w-2xl mx-auto" data-id="element-274" data-mp="1758f9pxloi27">
          <div className="bg-gray-900 p-5 md:p-8 rounded-3xl border-2 border-gray-800 shadow-2xl" data-id="element-275" data-mp="1c65vvy2yp41l">
            <h3 className="text-3xl md:text-4xl font-black text-white mb-1" data-id="element-276" data-mp="1h591bjmutca3">
              Megapack ESI Secundaria
            </h3>
            <p className="text-lg md:text-xl font-bold text-[#9D7FE0] mb-1" data-id="element-277" data-mp="1l4zxk2v5gkm0">
              25 temas + los 4 bonus
            </p>
            <p className="text-base text-gray-400 mb-5" data-id="element-278" data-mp="1pz462qk2d0p7">
              Todo lo que necesitás para trabajar ESI durante el año
            </p>

            <div className="flex justify-center mb-6" data-id="element-279" data-mp="1zw06e8zt6gio">
              <div className="h-44 md:h-56 flex items-center justify-center" data-id="element-280" data-mp="1zt4bktj9c7yg">
                <img src="https://cdn.magicpatterns.com/uploads/pRtZ4NNJpC3vWeMef8iJXA/ChatGPT_Image_29_jun_2026,_12_28_03_a.m._-_Editado.png" alt="Megapack ESI Secundaria + Todos los bonus" className="max-h-full max-w-full object-contain drop-shadow-2xl" data-id="element-281" data-mp="24utoyftycxpp" />
              </div>
            </div>

            <ul className="text-left space-y-2 mb-6 max-w-md mx-auto text-base md:text-lg text-gray-200" data-id="element-282" data-mp="1k4zelfr5z3nt">
              {esiIncludes.map(item => <li key={item} className="flex items-start" data-id="element-283" data-mp="1xyqq2toggxm6">
                  <span className="text-[#9D7FE0] mr-2 font-bold flex-shrink-0" data-id="element-284" data-mp="1swrmbioszyop">
                    ✔
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-285" data-mp="22x1zx4er384e">
              <p className="text-gray-400 text-sm uppercase tracking-widest font-bold mb-1" data-id="element-286" data-mp="22twcrupomgbb">
                Precio único
              </p>
              <p className="text-5xl md:text-6xl font-black text-white" data-id="element-287" data-mp="8ihlh9h0w8tg">
                ARS $19.990
              </p>
              <p className="text-sm text-gray-400 mt-1" data-id="element-288" data-mp="2k6dz6oz304nk">
                Pago único · Acceso de por vida
              </p>
            </div>

            <CTAButton href="https://checkout.aula-mater.online/cart/66941603479597:1" className="w-full text-xl md:text-2xl py-6 flex items-center justify-center gap-3" data-id="element-289" data-mp="2p5z034xtan2x">
              👉 LO QUIERO
            </CTAButton>
          </div>
        </div>

        {/* Opción 2: Pack Secundaria Completo */}
        <div className="relative mt-10 max-w-2xl mx-auto" data-id="element-290" data-mp="25h83vc3d6yky">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10" data-id="element-291" data-mp="1rgdtwp0o4pk6">
            <span className="inline-block bg-[#F5B301] text-black text-sm md:text-base font-black px-5 py-1.5 rounded-full shadow-lg whitespace-nowrap" data-id="element-292" data-mp="1ri8icdb5ezt0">
              ⭐ MÁS ELEGIDO
            </span>
          </div>

          <div className="bg-gray-900 p-5 md:p-8 pt-8 md:pt-10 rounded-3xl border-2 border-[#F5B301] shadow-2xl" data-id="element-293" data-mp="3lslx0pn58cr1">
            <h3 className="text-3xl md:text-4xl font-black text-white mb-1" data-id="element-294" data-mp="1qr09rbhem4wi">
              Pack Secundaria Completo
            </h3>
            <p className="text-lg md:text-xl font-bold text-[#F5B301] mb-1" data-id="element-295" data-mp="1lt8j0kshwotw">
              ESI + 8 Habilidades + Efemérides
            </p>
            <p className="text-base text-gray-400 mb-5" data-id="element-296" data-mp="1hsokpdw6rf66">
              Con esto completás todo el año escolar
            </p>

            <div className="grid grid-cols-2 gap-4 md:gap-6 mb-6 max-w-md mx-auto" data-id="element-297" data-mp="17s4hi5p3w0lb">
              {packMockups.map(item => <div key={item.alt} className="h-44 md:h-56 flex items-center justify-center" data-id="element-298" data-mp="130moc3tbr4aw">
                  <img src={item.src} alt={item.alt} className="max-h-full max-w-full object-contain drop-shadow-2xl" data-id="element-299" data-mp="y08ecg85xka8" />
                </div>)}
            </div>

            <ul className="text-left space-y-2 mb-6 max-w-md mx-auto text-base md:text-lg text-gray-200" data-id="element-300" data-mp="k44qd4nvu867">
              {packIncludes.map(item => <li key={item} className="flex items-start" data-id="element-301" data-mp="30p9pquqasq6b">
                  <span className="text-[#F5B301] mr-2 font-bold flex-shrink-0" data-id="element-302" data-mp="30nowr9jmtfak">
                    ✔
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-303" data-mp="39p56df2mhddq">
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-304" data-mp="2czxkg5y3d29a">
                <span className="text-lg md:text-xl text-gray-500 line-through font-bold" data-id="element-305" data-mp="2cxkwnc5njxob">
                  ARS $59.990
                </span>
                <span className="bg-red-600 text-white text-xs md:text-sm font-black px-3 py-1 rounded-full" data-id="element-306" data-mp="2m03svdexnc1l">
                  50% OFF
                </span>
              </div>
              <p className="text-5xl md:text-6xl font-black text-white" data-id="element-307" data-mp="1u9fto6wtkgqk">
                ARS $29.990
              </p>
              <p className="text-sm text-gray-400 mt-1" data-id="element-308" data-mp="1y9zsdex1jset">
                Pago único · Acceso de por vida
              </p>
            </div>

            <CTAButton href="https://checkout.aula-mater.online/cart/67392964984877:1" className="w-full text-xl md:text-2xl py-6 flex items-center justify-center gap-3 !bg-[#F5B301] !text-black !shadow-[0_0_25px_rgba(245,179,1,0.45)]" data-id="element-309" data-mp="31jufvf0tw7yv">
              👉 LO QUIERO
            </CTAButton>
          </div>
        </div>

        {/* Opciones secundarias */}
        <div className="mt-10 max-w-2xl mx-auto" data-id="element-310" data-mp="2in2yxc8re4xz">
          <CTAButton href="https://wa.me/5491124676057?text=Hola%20te%20hablo%20por%20el%20material%20Megapack%20ESI%20Secundaria%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion." className="!text-base md:!text-lg !py-3 !px-6 !animate-none flex items-center justify-center gap-2 !bg-gradient-to-r !from-[#25D366] !to-[#128C7E] !shadow-[0_0_15px_rgba(37,211,102,0.3)]" data-id="element-311" data-mp="2do9j3d6021un">
            <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-312" data-mp="2v599lhbfr5s">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-313" data-mp="fbxygj264aow" />
            </svg>
            COMPRA POR WHATSAPP
          </CTAButton>

          <div className="mt-8 pt-6 border-t border-gray-800" data-id="element-314" data-mp="2z56qryb30cm8">
            <CTAButton href="https://drive.google.com/file/d/1ZqdIgfzwfoPzzgBrRModpiAyELD53AHQ/view?usp=drive_link" className="!text-base md:!text-lg !py-3 !px-6 !animate-none flex items-center justify-center gap-2 !bg-gradient-to-r !from-[#5B3FA0] !to-[#9D7FE0] !shadow-[0_0_15px_rgba(91,63,160,0.3)]" data-id="element-315" data-mp="3vvz6uvy0m4o0">
              VER MUESTRA GRATIS
            </CTAButton>
          </div>

          <div className="flex flex-col md:flex-row flex-wrap justify-center items-center gap-x-5 gap-y-2 text-sm md:text-base font-bold text-gray-300 mt-6" data-id="element-316" data-mp="2biqkz2adflfr">
            <span className="flex items-center" data-id="element-317" data-mp="1wf70gpktq04i">
              <span className="text-green-500 mr-2" data-id="element-318" data-mp="1wcb3b3gsvfh4">✔</span> Secundaria
            </span>
            <span className="flex items-center" data-id="element-319" data-mp="21ds30vnjsvw4">
              <span className="text-green-500 mr-2" data-id="element-320" data-mp="26c1zd9l0e2jb">✔</span> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-321" data-mp="2b3tpxk46089g">
              <span className="text-green-500 mr-2" data-id="element-322" data-mp="2b4mnpvl5bnfg">✔</span> Descarga digital
            </span>
            <span className="flex items-center" data-id="element-323" data-mp="2f4ndgcdp3l1t">
              <span className="text-green-500 mr-2" data-id="element-324" data-mp="2k3gqk3p2la1g">✔</span> 25 temas
              fundamentales de ESI
            </span>
            <span className="flex items-center" data-id="element-325" data-mp="2p44hkpdatqvo">
              <span className="text-green-500 mr-2" data-id="element-326" data-mp="2p18kf399z68a">✔</span> Recursos para todo
              el ciclo lectivo
            </span>
          </div>
        </div>
      </div>
    </section>;
}